import type { JSX } from "react";

import { Avatar, type AvatarSize } from "@frontend/components/atoms/Avatar";

import type { ClientOption } from "../types";

export type ClientAvatarProps = {
  client: ClientOption;
  className?: string;
  size?: AvatarSize;
};

export function ClientAvatar({
  client,
  className,
  size = "sm",
}: ClientAvatarProps): JSX.Element {
  return (
    <Avatar
      className={className}
      url={client.hasPhoto ? (client.avatarUrl ?? undefined) : undefined}
      kind={client.isOrganization ? "organization" : "person"}
      size={size}
    />
  );
}
